import {currentUserId, db} from "@/plugins/fire-base";
import {addDoc, collection, doc, query, setDoc, updateDoc, where} from "firebase/firestore";
import {executeQuery} from "@/dataLayer/service/utils";
import GlobalConfig from "@/dataLayer/repository/GlobalSettingManager";
import {getCurrentRestaurantInfo} from "@/dataLayer/repository/restaurantInfo";
import {orderBy} from "lodash-es";
import dayjs from "dayjs";

const path = 'takeaway-user-order'
const paypalPath = 'takeaway-checkout-paypal'

export async function setOrderForUser(orderInfo) {
    orderInfo.userId = currentUserId()
    orderInfo.dataTerminalId = GlobalConfig.dataTerminalId
    orderInfo.deviceId = GlobalConfig.deviceId
    orderInfo.restaurantName = (await getCurrentRestaurantInfo()).name
    const id = orderInfo.id.toString()
    try {
        await setDoc(doc(db, path, id), orderInfo)
        return true
    } catch (e) {
        console.log(e)
        return false
    }

}

export async function setPayPalOrderForUser(orderInfo) {
    orderInfo.userId = currentUserId()
    orderInfo.dataTerminalId = GlobalConfig.dataTerminalId
    orderInfo.deviceId = GlobalConfig.deviceId
    orderInfo.restaurantName = (await getCurrentRestaurantInfo()).name
    orderInfo.createDate = dayjs().format('YYYY-MM-DD HH:mm:ss')
    try {
        return (await addDoc(collection(db, paypalPath), orderInfo)).id
    } catch (e) {
        console.log(e)
        return false
    }

}

export async function updatePayPalOrderForUser(orderInfo,firebaseId) {
    try {
        await updateDoc(doc(db, paypalPath, firebaseId), orderInfo)
        return true
    } catch (e) {
        console.log(e)
        return false
    }

}


export async function getAllOrdersForUser() {
    return orderBy(await executeQuery(query(collection(db, path),
        where('userId', '==', currentUserId()))),
        (order) => [order.addressInfo.date + order?.addressInfo.time],
        ['desc'])
}
